export enum LlmType {
  OpenAI = "openai",
  Anthropic = "anthropic",
}

export const GraphIntervals: Array<{ value: string; label: string }> = [
  {
    value: "daily",
    label: "Daily",
  },
  {
    value: "three_day",
    label: "3 Day",
  },
  {
    value: "weekly",
    label: "Weekly",
  },
  {
    value: "monthly",
    label: "Monthly",
  },
];
